import type { IReactionDisposer } from 'mobx';
import { reaction } from 'mobx';
import { useEffect, useState } from 'react';
import type { IBaseViewModel } from '@/engine/app/interfaces';
import type { BoolFunction } from './types';

export const useHighlight = (itemVMs: Array<IBaseViewModel> | undefined): { isHighlighted: BoolFunction } => {
  const [highlighted, setHighlighted] = useState<string | undefined>(undefined);
  const isHighlighted: BoolFunction = (descriptor) => highlighted === descriptor;

  const totalItems = itemVMs?.length;

  useEffect(() => {
    const highlightingReactionDisposers: Array<IReactionDisposer> = [];
    if (itemVMs) {
      itemVMs.forEach((viewModel) => {
        highlightingReactionDisposers.push(
          reaction(
            () => viewModel.isHighlighted,
            (highlighting: boolean) => {
              if (highlighting) {
                setHighlighted(viewModel.descriptor);
              } else {
                setHighlighted(undefined);
              }
            }
          )
        );
      });
    }
    return (): void => {
      highlightingReactionDisposers.forEach((disposer) => disposer());
    };
  }, [itemVMs, totalItems]);
  return { isHighlighted };
};
